export const PALETTE = [
  '#047DBA',
  '#90FFBB',
  '#E0FF48',
  '#F3BDFF',
  '#7F9FFF',
  '#00BDB9',
  '#00CFFF',
  '#0284A2',
  '#D20BFF',
  '#CDE5F1',
  '#7EFFFC',
  '#ECFF91',
  '#008BAA',
  '#E46DFF',
  '#4876FF',
  '#00A19D',
  '#BEE400',
  '#B2C5FF',
  '#7F009B',
  '#9BCBE3',
  '#01314A',
  '#18FF71',
  '#1EFFFA',
  '#06605E',
  '#A8E2E1',
  '#009F3D',
  '#9EC7C6',
  '#008481',
  '#95B300',
  '#025782',
  '#B500DE',
  '#00EDE8',
  '#6C8200',
  '#436F86',
];
